import React, { useEffect, useRef } from "react";
import Layout from "../../../components/admin/Layout";
import Helmet from "react-helmet";
import Table from "../../../components/ui/Table";
import usePaginate from "../../../hooks/api/usePaginate";
import apiRequest from "../../../utils/admin/apiRequest";
import useModal from "../../../hooks/ui/useModal";
import Pagination from "../../../components/ui/Pagination";
import { FaEdit, FaPlus, FaTrashAlt } from "react-icons/fa";
import Modal from "../../../components/ui/utils/Modal";
import Button from "../../../components/ui/utils/Button";
import useFormInput from "../../../hooks/form/useFormInput";
import { useSelector } from "react-redux";

import InputField from "../../../components/ui/form/InputField";
import CreateCountry from "../../../components/admin/address/country/CreateCountry";
import EditCountry from "../../../components/admin/address/country/EditCountry";
import DeleteCountry from "../../../components/admin/address/country/DeleteCountry";

const Country = () => {
    const {
        currentPage,
        data,
        error,
        fetchData,
        limit,
        loading,
        setPage,
        setSorting,
        sort,
        totalItems,
        totalPages,
        setFilters,
    } = usePaginate({
        apiMethod: apiRequest.getCountry,
        dataKey: "countries",
    });
    
    

    
    const { isOpen, openModal, closeModal, actionType } = useModal();
    
    const handleSort = (field) => {
        const order =
            sort.sortField === field && sort.sortOrder === "asc" ? "desc" : "asc";
        setSorting({ sortField: field, sortOrder: order });
    };

    const searchInitialValues = { name: "" };
    const { values, handleChange, setValues } = useFormInput(searchInitialValues);
    console.log(values);
    
    const debounceRef = useRef(null);
    useEffect(() => {
        if (values.name !== undefined) {
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }
            debounceRef.current = setTimeout(() => {
                const filters = {};
                if (values.name) {
                    filters.name = { $regex: values.name, $options: "i" };
                }
                setFilters(filters);
            }, 500);
            return () => clearTimeout(debounceRef.current);
        }
    }, [values.name]);

    const BRAND_NAME = useSelector(
        (state) => state.globalState?.siteSetting?.site_settings?.site_name
    );
    return (
        <Layout>
            <Helmet>
                <title>Country - {BRAND_NAME ?? ''}</title>
            </Helmet>
            <div className="p-4 bg-white rounded">
                <div className="flex items-center gap-1 py-2">
                    <Button
                        onClick={() => openModal({ type: "add" })}
                        variant="primary"
                        isLoading={false}
                    >
                        <div className="flex items-center justify-center gap-3">
                            <FaPlus />
                            <p>Add New</p>
                        </div>
                    </Button>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-[1fr_100px] gap-2 my-2">
                    <InputField
                        name="name"
                        placeholder="e.g. country"
                        value={values.name}
                        onChange={handleChange}
                    />
                    <button
                        className="py-1 text-white rounded bg-emerald-600 hover:bg-emerald-800"
                        onClick={() => setValues(searchInitialValues)}
                    >
                        Clear
                    </button>
                </div>

                <Table
                    headers={[
                        { label: "Name", key: "name", sorting: true },
                        { label: "Code", key: "code", sorting: true },
                        { label: "Status", key: "status", sorting: true },
                        { label: "Created At", key: "createdAt", sorting: true },
                        {
                            label: "Action",
                            key: "action",
                            sorting: false,
                        },
                    ]}
                    loading={loading}
                    handleSort={handleSort}
                    sort={sort}
                    error={error}
                    cols={7}
                    renderRow={
                        <tbody className="bg-white divide-y divide-gray-200">
                            {data?.map((country) => {

                                return (
                                    <tr key={country._id} className="transition-colors hover:bg-gray-50">
                                        <td className="px-3 py-3">
                                            <span className="font-semibold text-gray-800">{country.name}</span>
                                        </td>
                                        <td className="px-3 py-3">
                                            <span className="font-semibold text-gray-800">{country.code}</span>
                                        </td>
                                        <td className="px-3 py-3">
                                            <span className="text-xs text-gray-500">{country.status ? 'Active' : 'Blocked'}</span>
                                        </td>
                                    
                                        <td className="px-3 py-3">
                                            <span className="text-xs text-gray-400">
                                                {new Date(country.createdAt).toLocaleDateString()}
                                            </span>
                                        </td>

                                        <td className="px-3 py-3">
                                            <div className="flex justify-center gap-3">
                                                <button
                                                    onClick={() => openModal({ type: "edit", data: { state: country } })}
                                                    className="text-primary"
                                                    title="Edit"
                                                >
                                                    <FaEdit size={18} />
                                                </button>
                                                <button
                                                    onClick={() => openModal({ type: "delete", data: { state: country } })}
                                                    className="text-red-500"
                                                    title="Delete"
                                                >
                                                    <FaTrashAlt size={18} />
                                                </button>
                                            </div>
                                        </td>

                                    </tr>
                                );
                            })}
                        </tbody>
                    }
                />
                {totalPages > 1 && (
                    <Pagination
                        pagination={{
                            currentPage,
                            totalPages,
                            totalItems: totalItems,
                            perPage: limit,
                        }}
                        handlePageChange={setPage}
                        loading={loading}
                    />
                )}
            </div>
            <Modal isOpen={isOpen} onClose={closeModal} size="large">
                {actionType?.type === "add" && (
                    <CreateCountry closeModal={closeModal} callback={fetchData} />
                )}
                {actionType?.type === "edit" && (
                    <EditCountry
                        data={actionType?.data?.state}
                        closeModal={closeModal}
                        callback={fetchData}
                    />
                )}
                {actionType?.type === "delete" && (
                    <DeleteCountry
                        data={actionType?.data?.state}
                        closeModal={closeModal}
                        callback={fetchData}
                    />
                )}
            </Modal>
        </Layout>
    );
};

export default Country;
